"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PowerSolutionsOverview() {
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line3Ref,
    isVisible: line3Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "EST. 2005"
  }, {
    label: "CERTIFIED"
  }, {
    label: "24/7 READY"
  }];
  return <section data-section-id="4781" id="power-solutions-overview" className="dark relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700070/img/electrician_panel_work.webp)]" />

      {}
      <div className="absolute inset-0 z-10" style={{
      background: "radial-gradient(ellipse at 75% 75%, hsla(215, 60%, 12%, 0.65) 0%, hsla(215, 60%, 8%, 0.85) 45%, hsla(215, 60%, 8%, 0.96) 80%)"
    }} />

      {}
      <div className="absolute inset-0 z-10 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 40%, hsla(215, 60%, 8%, 0.7) 100%)"
    }} />

      {}
      <div className="absolute inset-0 z-10 opacity-[0.08] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 z-20 px-6 sm:px-10 pt-6 sm:pt-8">
        <div className="flex items-center justify-between gap-4 mb-4">
          <span className="font-mono text-[10px] sm:text-xs tracking-widest text-foreground/70 uppercase">
            — PRECISION ELECTRICAL INFRASTRUCTURE
          </span>
          <span className="font-mono text-[10px] sm:text-xs tracking-widest text-foreground/70 uppercase">
            CURRENT PULSE · LICENSED
          </span>
        </div>
        <div className="h-px w-full bg-foreground/20" />
      </div>

      {}
      <div className="relative z-20 min-h-screen flex flex-col justify-center px-6 sm:px-10 lg:px-16 pt-32 pb-32">
        <div className="max-w-7xl w-full mx-auto">
          {}
          <div className="space-y-1 sm:space-y-2 mb-10 sm:mb-12">
            <div ref={line1Ref} className="overflow-hidden">
              <h1 className={`font-default font-bold leading-[0.9] tracking-tighter text-foreground transition-all duration-1000 ease-out ${line1Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
              fontSize: "clamp(3.5rem, 12vw, 11rem)"
            }}>
                Powering
              </h1>
            </div>
            <div ref={line2Ref} className="overflow-hidden">
              <h1 className={`font-default font-bold leading-[0.9] tracking-tighter text-foreground transition-all duration-1000 ease-out delay-150 ${line2Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
              fontSize: "clamp(3.5rem, 12vw, 11rem)"
            }}>
                your world,
              </h1>
            </div>
            <div ref={line3Ref} className="overflow-hidden">
              <h1 className={`font-default font-bold leading-[0.9] tracking-tighter text-foreground transition-all duration-1000 ease-out delay-300 ${line3Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
              fontSize: "clamp(3.5rem, 12vw, 11rem)"
            }}>
                with precision
                <span style={{
                color: "var(--primary)"
              }}>.</span>
              </h1>
            </div>
          </div>

          {}
          <p ref={paraRef} className={`font-default text-base sm:text-lg text-foreground/75 leading-relaxed max-w-[50ch] mb-10 transition-all duration-1000 ease-out delay-500 ${paraVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            Current Pulse Electric delivers expert residential and commercial electrical solutions. From complex installations to emergency repairs, we ensure your systems run safely and efficiently.
          </p>

          {}
          <div ref={ctaRef} className={`flex flex-col sm:flex-row gap-4 transition-all duration-1000 ease-out delay-700 ${ctaVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
            <div className="relative group">
              <div className="absolute inset-0 rounded-lg blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500 animate-pulse" style={{
              backgroundColor: "var(--primary)"
            }} />
              <Button asChild size="lg" className="relative font-default text-xs tracking-widest uppercase h-12 px-7 bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg">
                <Link to="/LetsTalkPage">
                  Request Service Now
                  <ArrowUpRight className="ml-1 size-4" />
                </Link>
              </Button>
            </div>
            <Button asChild variant="outline" size="lg" className="font-default text-xs tracking-widest uppercase h-12 px-7 bg-transparent border border-foreground/40 text-foreground hover:bg-foreground/10 hover:text-foreground rounded-lg">
              <Link to="/OurExpertisePage">View Our Services</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-6 sm:bottom-10 left-6 sm:left-10 z-20 hidden sm:flex flex-col items-start gap-3">
        <span className="font-mono text-[10px] tracking-widest text-foreground/70 uppercase [writing-mode:vertical-rl] rotate-180">
          SCROLL — 01
        </span>
        <div className="relative h-16 w-px bg-foreground/20 overflow-hidden">
          <div className="absolute top-0 left-0 w-full bg-primary animate-[scrollLine_2s_ease-in-out_infinite]" style={{
          height: "40%"
        }} />
        </div>
      </div>

      {}
      <div className="absolute bottom-6 sm:bottom-10 right-6 sm:right-10 z-20 flex items-center gap-3 sm:gap-5">
        {stats.map((stat, i) => <div data-index={i} key={stat.label} className="flex items-center gap-3 sm:gap-5">
            {i > 0 && <div className="h-3 w-px bg-foreground/30" />}
            <span className="font-mono text-[10px] sm:text-xs tracking-widest text-foreground/80 uppercase">
              {stat.label}
            </span>
          </div>)}
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
      `}</style>
    </section>;
}